import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE_HOVER } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(0, -2),

    [theme.breakpoints.down('md')]: {
      overflowX: 'scroll',
      overflowY: 'hidden',
      flexWrap: 'nowrap',
    },
  },
  forMobile: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(0, -2),

    [theme.breakpoints.down('md')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      justifyItems: 'center',
    },
  },
  item: {
    width: ({ columns }) => `calc(100% / ${columns})`,
    padding: theme.spacing(2, 2),

    [theme.breakpoints.down('md')]: {
      minWidth: 200,
    },
  },
  itemForMobile: {
    width: ({ columns }) => `calc(65% / ${columns})`,
    padding: theme.spacing(2, 2),

    [theme.breakpoints.down('md')]: {
      width: () => `calc(100% / 1.2)`,
      padding: theme.spacing(2, 0.5),
    },
  },
  thumb: {
    display: 'inline-block',
    position: 'relative',
    boxShadow: theme.shadows[2],
  },
  thumbLink: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    textAlign: 'center',
    color: theme.palette.common.white,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textDecoration: 'none !important',
    backgroundColor: 'rgba(0, 0, 0, .7)',
    opacity: 0,
    transition: `opacity 300ms ${theme.transitions.easing.easeInOut}`,

    '&:hover': {
      opacity: 1,
    },
  },
  thumbImage: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),

    '& li:not(:first-child, :last-child) button': {
      color: COLOR_PURPLE_HOVER,
    },

    '& li button.Mui-selected, & li button.Mui-selected:hover': {
      color: `${theme.palette.common.white} !important`,
      backgroundColor: COLOR_PURPLE_HOVER,
    },
  },
  btnSeeMoreMobile: {
    color: COLOR_PURPLE_HOVER,
    fontFamily: 'Lato',
    fontSize: 16,
    textDecoration: 'none',
    display: 'flex',
  },
  imageSlugPage: {
    width: 138,
    height: 78,
  },
}));
